module.exports = __webpack_public_path__ + "06d5ea081405bbe644ac0989225ed699.MP3";